(() => {
  class FreeShippingBanner extends HTMLElement {
    connectedCallback() {
      this.textElement = this.querySelector('[data-free-shipping-text]');
      this.threshold = Number(this.dataset.threshold || 5000);
      this.currency = this.dataset.currency || 'EUR';
      this.abortController = new AbortController();
      this.refreshTimer = null;
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.resizeObserver.observe(this);
      this.updateHeight();

      document.addEventListener('cart:change', (event) => {
        const cart = event.detail?.cart;
        if (cart) this.update(cart);
        else this.scheduleRefresh();
      }, { signal: this.abortController.signal });

      document.addEventListener('cart:refresh', () => this.scheduleRefresh(), {
        signal: this.abortController.signal
      });

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.scheduleRefresh();
      }, { signal: this.abortController.signal });

    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      window.clearTimeout(this.refreshTimer);
    }

    updateHeight() {
      document.documentElement.style.setProperty(
        '--free-shipping-banner-height',
        `${this.getBoundingClientRect().height.toFixed(2)}px`
      );
    }

    scheduleRefresh() {
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.refresh(), 120);
    }

    async refresh() {
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart could not be loaded');
        this.update(await response.json());
      } catch {
        // The server-rendered value remains visible if the cart request fails.
      }
    }

    update(cart) {
      if (!this.textElement) return;

      const cartTotal = Number(cart?.total_price || 0);
      const remaining = this.threshold - cartTotal;
      this.currency = cart?.currency || this.currency;

      if (remaining <= 0) {
        this.textElement.textContent = '🎉 Kostenlosen Versand gesichert!';
      } else if (cartTotal > 0) {
        this.textElement.textContent = `📦 Nur noch ${this.formatMoney(remaining)} bis zum kostenlosen Versand`;
      } else {
        this.textElement.textContent = `📦 Kostenloser Versand ab ${this.formatMoney(this.threshold)}`;
      }
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: this.currency
        }).format(cents / 100);
      } catch {
        return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
      }
    }
  }

  if (!customElements.get('free-shipping-banner')) {
    customElements.define('free-shipping-banner', FreeShippingBanner);
  }
})();
